<div>
  <div style="text-align: right; margin-bottom: 2%;">
    <button id="print-button" class="noPrint" style="margin-top: 2%; margin-right: 1%;" 
            mat-raised-button color="primary"
            printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button (click)="print()" class="noPrint" 
        style="display: none; margin-top: 2%; margin-right: 1%;" 
        mat-raised-button color="primary">
  Print
</button>


    <button class="noPrint" style="margin-top: 2%;" mat-button mat-dialog-close>
      Close
    </button>
  </div>

  <div class="container">
    <div id="print-section">
      <!-- Header -->
      <div style="text-align: center; font-weight: bold; font-size: xx-large; margin-bottom: 10px;color: black !important;">
        प्रतिनिधी प्रसिद्धी पत्रक
      </div>

      <div style="display: grid; grid-template-columns: 1fr 1fr 1fr; font-weight: bold; margin-bottom: 20px;">
        <span style="text-align: left; padding-left: 15px;color: black !important;">
          अंक नाव :- {{ issuenamenew }}
        </span>
        <span style="text-align: center;color: black !important;">
          अंक दिनांक :- {{ issuedatepp | date : 'dd-MM-yyyy' }}
        </span>
        <span style="text-align: right; padding-right: 15px;color: black !important;">
          दिनांक :- {{ currentDate | date: 'dd-MM-yyyy' }}
        </span>
      </div>

      <hr>

      <!-- Address Cards -->
      <div class="row" style="display: flex; flex-wrap: wrap; margin-left: 25px;">
  <div *ngFor="let data2 of Address"
        class="col"
       style="flex: 0 0 33.33%; padding: 12px; box-sizing: border-box; page-break-inside: avoid;color: black !important;">
    <b style="font-size: 20px;color: black !important;">{{ data2.issueSellerName }}</b><br>
    <span style="font-size: 18px;color: black !important;">{{ data2.address }}</span><br>
    <span style="font-size: 18px;color: black !important;">{{ data2.taluka }}</span><br>
    <span style="font-size: 18px;color: black !important;">{{ data2.district }} - {{ data2.pincode }} {{ data2.state }}</span><br>
    <b style="font-size: 18px;color: black !important;">मो.क्र. {{ data2.mobile_no }}</b>
  </div>
</div>
    </div>
  </div>
</div>
